import React from "react";
import { message, Alert } from "antd";
import { inject, observer } from "mobx-react";

import Language from "../../language/language";
import KvItem from "./kvItem";
import UpdateSchoolInfo from "./updateSchoolInfo";
import verifyCurInfo from "./verifySchoolInfo";
import agent from "../../../agent";

import "../stylesheets/collegesInfo.scss";

const infoKeysList = [
  { key: "name", source: "SCHOOL_FULL_NAME_ZH" },
  { key: "shortName", source: "SCHOOL_SHORT_NAME_ZH" },
  { key: "enName", source: "SCHOOL_FULL_NAME_EN" },
  { key: "shortEnName", source: "SCHOOL_SHORT_NAME_EN" }
];

@inject("languageStore", "teamStore")
@observer
class CollegesInfo extends React.Component {
  state = {
    visible: false,
    curInfo: null,
    warningTips: []
  };

  async componentDidMount() {
    // 不可编辑状态下不校验学校信息。
    if (this.props.info && this.props.edit) {
      const data = await verifyCurInfo(this.props.info);
      const warningTips = data.filter(
        item => Array.isArray(item.warningTipItem) && item.warningTipItem.length > 0
      );
      this.setState({
        warningTips
      });
      this.props.teamStore.setAllInfoLegalState(!(warningTips.length > 0));
    }
  }

  updateInfo = item => {
    this.setState({
      visible: true,
      curInfo: item
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false
    });
  };

  afterOk = () => {
    message
      .success(
        this.props.languageStore.getResource(
          this.props.languageStore.lang,
          "UPDATE_SCHOOL_INFO_SUC"
        ),
        1
      )
      .then(() => {
        window.location.reload();
      });
  };

  handleOk = data => {
    // 传teamId用于服务端更新队伍的学校信息
    const teamId = this.props.teamStore.teamInfo.id;
    return agent.SassPlatform.updateSchoolInfo({ ...data, teamId })
      .then(res => {
        if (res && res.success && res.data) {
          this.setState(
            {
              visible: false
            },
            this.afterOk
          );
          return Promise.resolve();
        }
        return Promise.reject("failed");
      })
      .catch(err => {
        console.error(err);
        if (err && err.response && err.response.body && err.response.body.code === "B3000004") {
          message.error(
            this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "UPDATE_SCHOOL_INFO_ERROR_EXISTING"
            )
          );
        } else {
          message.error(
            this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "UPDATE_SCHOOL_INFO_ERROR"
            )
          );
        }
        return Promise.reject(err);
      });
  };

  renderWarningTips = (id, tips) => {
    if (
      !(
        tips &&
        tips.warningTipItem &&
        Array.isArray(tips.warningTipItem) &&
        tips.warningTipItem.length > 0
      )
    )
      return null;
    const lang = this.props.languageStore.lang;

    return tips.warningTipItem.map((tipItem, index) => {
      const { type, tip } = tipItem;
      return (
        <Alert
          className="collegesInfo__box--tips"
          key={`${id}-${index + 1}`}
          message={
            type === 1
              ? this.props.languageStore.getResource(lang, tip)
              : this.props.languageStore.getResource(lang, "IS_REQUIRED_INPUT", [
                  this.props.languageStore.getResource(lang, tip)
                ])
          }
          type="warning"
          showIcon
        />
      );
    });
  };

  render() {
    const { info, edit } = this.props;
    const { visible, curInfo, warningTips } = this.state;

    return (
      <div className="collegesInfo">
        {info.map((item, index) => {
          const { id, country, province, city } = item;
          const address = [...new Set([country, province, city])].filter(Boolean).join("/");
          const curWarningTips = warningTips.find(tip => tip.id === id);

          return (
            <div key={`itemBox-${id}-${index}`} className="collegesInfo__box">
              {curWarningTips ? this.renderWarningTips(id, curWarningTips) : null}
              <div className="collegesInfo__title">
                <Language className="collegesInfo__title--sub" resource="COLLEGES_INFO" />
                {edit ? (
                  <div
                    className="collegesInfo__title--update"
                    onClick={() => this.updateInfo(item)}
                  >
                    <Language resource="EDIT_TEAM_INFO" />
                  </div>
                ) : null}
              </div>
              {infoKeysList.map((keyItem, keyIndex) => {
                return (
                  <KvItem
                    key={`item-${id}-${keyIndex}`}
                    vskey={keyItem.source}
                    value={item[keyItem.key] || "-"}
                  />
                );
              })}
              <Language className="collegesInfo__title--sub" resource="SCHOOL_ADDRESS" />
              {`: ${address}`}
            </div>
          );
        })}
        {visible && curInfo && (
          <UpdateSchoolInfo
            visible={visible}
            info={curInfo}
            title={<Language resource="UPDATE_SCHOOL_INFO" />}
            onCancel={this.handleCancel}
            onOk={this.handleOk}
          />
        )}
      </div>
    );
  }
}

export default CollegesInfo;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/collegesInfo.js